$(document).ready(function () {
    $('.js_view_model').on('click', function () {
        $(this).toggleClass('js_active_button');
        $(this).closest('.brand_block').find('.model_list li').toggleClass('d-block');
    });

    $('.letters_filter_button').on('click', function () {
        $(this).toggleClass('js_open_block');
        $(this).parent('.letters_filter')
            .find('.letters_filter_list').toggleClass('js_open_block');
    });

    $('.js_activate_block_letter').each(function () {
        const letter = $(this).find('.js_button_letter').text();
        $(`.js__models_switcher[data-letter=${letter}]`).addClass('active');
        $(`.js__models_items[data-letter=${letter}]`).addClass('active');
    })


    $(document).on('click', '.js__models_switcher', function (e) {
        e.stopPropagation();
        e.preventDefault();
        let letter = $(this).attr('data-letter');
        $(this).closest('.section_page')
            .find(".js__models_items").removeClass('active');
        $(this).closest('.section_page')
            .find(".js__models_switcher").removeClass('active');

        $(this).addClass('active');

        $(this).closest('.letters_filter').find('.js_button_letter')
            .text(letter).removeClass('js_open_block');
        $('.letters_filter_list').removeClass('js_open_block')
        $(this).closest('.section_page')
            .find(".js__models_items[data-letter='" + letter + "']").addClass('active');
    });

    if ($(window).width() >= 768) {
        editHeightAboutBlock();
    } else {
        editHeightAboutBlock(true);
    }

    $('.js_open_menu_footer').on('click', function () {
        if ($(this).closest('.footer_perent_menu').find('.footer_menu_children').length == 1) {
            $(this).toggleClass('js_active');
            $(this).closest('.footer_perent_menu').find('.footer_menu_children').toggleClass('js_active')
        }
    });
});

function editHeightAboutBlock(widthWindow = null) {
    $('.servis_about_us').each(function () {
        const heightImg = $(this).find('.block_image .img_resp').outerHeight(true);
        (!widthWindow)
            ? $(this).find('.block_text').css('height', `${heightImg}px`)
            : $(this).find('.block_text').css('height', ``)
    })
}

$(window).resize(function () {
    if ($(window).width() >= 768) {
        editHeightAboutBlock();
    } else {
        editHeightAboutBlock(true);
    }
});